import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import matchSorter from 'match-sorter';
import {
  Col,
  FormGroup,
  Label,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import FilterTermsSelectItem from '../../FilterTermsSelectItem';
import SelectVirtualMenuList from '../../SelectVirtualMenuList';

const AdminReportsFilterTaxonomy = ({
  taxonomy,
  terms,
  handleChange,
}) => {
  const intl = useIntl();

  const [inputValue, setInputValue] = useState([]);

  const getTermsOptions = () => {
    const options = [];

    if (taxonomy.terms) {
      taxonomy.terms.forEach((term) => {
        options.push({
          value: `${term.id}`,
          label: term.name,
          taxonomyId: taxonomy.id,
        });
      });
    }

    return options;
  };

  return (
    <Col sm="6" md="5" lg="4" xl="3" className="report-taxonomy-filter-wrapper">
      <FormGroup>
        <Label for={`taxonomy-${taxonomy.id}`}>{taxonomy.plural}</Label>
        <Select
          id={`taxonomy-${taxonomy.id}`}
          className="report-taxonomy-filter"
          name={`taxonomy-${taxonomy.id}`}
          components={{
            MenuList: SelectVirtualMenuList,
            Option: FilterTermsSelectItem,
          }}
          isMulti
          filterOption={false}
          placeholder={intl.formatMessage({ defaultMessage: '"Select"' })}
          options={matchSorter(getTermsOptions(), inputValue, { keys: ['label'] })}
          onInputChange={(v) => { setInputValue(v); }}
          onChange={handleChange}
          value={terms.filter(t => (t.taxonomyId === taxonomy.id))}
        />
      </FormGroup>
    </Col>
  );
};

AdminReportsFilterTaxonomy.propTypes = {
  terms: PropTypes.array.isRequired,
  taxonomy: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default AdminReportsFilterTaxonomy;
